import { Controller } from "@hotwired/stimulus";
import { format } from 'sql-formatter';

export default class extends Controller {

  static values = {
    sqlVariant: { default: 'sqlite' }
  }

  connect() {
    if (this.element.textContent.length > 80) {
      try {
        this.element.textContent = format(this.element.textContent, { language: this.sqlVariantValue })
      }
      catch {
        // Leave the SQL as written when it cannot be formatted.
      }
    }
  }
}
